import { React, useEffect, useContext, useState } from 'react';
import { AuthContext } from '../../../contexts/authContext';
import { Link, useNavigate, NavLink } from 'react-router-dom';

import { Loader, Modal, TextInput, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconUser, IconLock, IconFileCertificate, IconBrandHipchat, IconChevronRight, IconArticle, IconReceipt, IconLeaf, IconRecycle, IconGift } from '@tabler/icons-react';

import AppNavbarSyndic from '../../Navbar/NavbarApp';
import AppHdSingleTitle from '../../../composents/Headers/AppHeaders/AppHdSingleTitle/AppHdSingleTitle'

const ProfileMenu = () => {
    const { getToken } = useContext(AuthContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const [ menuProfile , setMenuProfile ] = useState(null)
    const [ co2Impact , setCo2Impact ] = useState(null)
    const [referOpened, { open: openRefer, close: closeRefer }] = useDisclosure(false);
    const [referEmail, setReferEmail] = useState("");
    const [referSending, setReferSending] = useState(false);
    const [referSent, setReferSent] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        }
        getUser()
        getCo2Impact()

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
      
          window.addEventListener('resize', handleResize);
      
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);


    const getUser = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) return;
            const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/app/getUser', {
            // const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/s/getUser', {

                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`
                    }
        });
            // On ne déconnecte que si le token envoyé avec CETTE requête est toujours celui en
            // place (évite qu'une requête en vol, répondant après un logout/login entre-temps,
            // redéclenche une déconnexion sur un token qui n'est plus le bon).
            if (response.status === 401) {
                if (localStorage.getItem("token") === token) {
                    localStorage.removeItem("token");
                    sessionStorage.removeItem("user");
                    sessionStorage.removeItem("userType");
                    navigate("/app/login");
                }
                return;
            }
            const data = await response.json()
            setMenuProfile(data)
        }   catch (error) {
            return null;
        }
    }

    const getCo2Impact = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/app/profile/co2-impact', {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) return;
            const data = await response.json();
            setCo2Impact(data);
        } catch (error) {
            return null;
        }
    }

    const closeReferModal = () => {
        closeRefer();
        setReferEmail("");
        setReferSent(false);
    };

    const handleSendReferral = async () => {
        if (!referEmail || referSending) return;
        setReferSending(true);
        try {
            const token = localStorage.getItem("token");
            const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/app/profile/refer', {
                method: "POST",
                body: JSON.stringify({ email: referEmail }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.ok) {
                setReferSent(true);
            }
        } catch (error) {
        } finally {
            setReferSending(false);
        }
    };

    const fmtCo2 = (kg) => {
        if (!kg) return "≈ 0 kg CO₂e";
        return kg >= 1000
            ? `≈ ${(kg / 1000).toLocaleString("fr-FR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} t CO₂e`
            : `≈ ${Math.round(kg).toLocaleString("fr-FR")} kg CO₂e`;
    }

    return(
        menuProfile ?
            <>
                {isMobile ? (
                    <>
                        <AppHdSingleTitle>Profil</AppHdSingleTitle>
                        <AppNavbarSyndic />
                        
                        <div className="horizontal width90pCenter mrgB10">
                            <div className="vertical">
                                <p className='txt18 medium noMrgB'>{menuProfile.firstname} {menuProfile.lastname}</p>
                                <p className='txt15 capitals dGreyT noMrgT noMrgB'>{menuProfile.company.name}</p>
                            </div>
                        </div>

                        {co2Impact && (co2Impact.asSellerKg > 0 || co2Impact.asBuyerKg > 0) && (
                            <div className="width90pCenter mrgB20">
                                <p className='txt13 bold dGreyT noMrgB'>Votre impact</p>
                                <div className="horizontal iCenter spaceBtw radiusgreen" style={{ backgroundColor: '#f1f8f2', padding: '12px 16px', gap: 10 }}>
                                    <div className="vertical" style={{ flex: 1 }}>
                                        <div className="horizontal iCenter" style={{ gap: 6 }}>
                                            <IconLeaf color="#2e7d32" width={18} />
                                            <p className='txt13 noMrgTB'>Ventes/dons</p>
                                        </div>
                                        <p className='txt15 bold noMrgTB' style={{ color: '#2e7d32' }}>{fmtCo2(co2Impact.asSellerKg)}</p>
                                    </div>
                                    <div className="vertical" style={{ flex: 1 }}>
                                        <div className="horizontal iCenter" style={{ gap: 6 }}>
                                            <IconRecycle color="#2e7d32" width={18} />
                                            <p className='txt13 noMrgTB'>Achats</p>
                                        </div>
                                        <p className='txt15 bold noMrgTB' style={{ color: '#2e7d32' }}>{fmtCo2(co2Impact.asBuyerKg)}</p>
                                    </div>
                                </div>
                                <p className='txt11 thin dGreyT noMrgT'>potentiellement évités grâce au réemploi</p>
                            </div>
                        )}

                        <div>
                            <NavLink to = "/app/offers/list" className="btnReset aReset bT">
                            <div className="horizontal iCenter spaceBtw bDarkGreen mrgB30 radiusgreen width90pCenter">
                                <div className="horizontal iCenter paddingMenuProfil">
                                    <IconArticle color="green" width={25} className="mrgR10"/>
                                    <p className='bold'>Mes offres</p>
                                </div>
                            </div>
                            </NavLink>

                            <div  className="profil-menu vertical mrgL10 mrgR20 mrgB20">
                                <Link to={`/app/profile/orders`} className="aReset bT">
                                        <div className="horizontal iCenter spaceBtw">
                                            <div className="horizontal iCenter paddingMenuProfil">
                                                <IconReceipt  color="green" width={25} className="mrgR10"/>
                                                <p>Mes transactions</p>
                                            </div>
                                            <IconChevronRight width={16}/>                                
                                        </div>
                                        <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                </Link>

                                
                                <Link to={`/app/profile/account`} className="aReset bT">
                                        <div className="horizontal iCenter spaceBtw">
                                            <div className="horizontal iCenter paddingMenuProfil">
                                                <IconUser color="green" width={25} className="mrgR10"/>
                                                <p>Mon compte</p>
                                            </div>
                                            <IconChevronRight width={16}/>                                
                                        </div>
                                        <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                </Link>

                                <Link to={`/app/profile/param/psw-edit`} className="aReset bT">
                                        <div className="horizontal iCenter spaceBtw">
                                            <div className="horizontal iCenter paddingMenuProfil">
                                                <IconLock color="green" width={25} className="mrgR10"/>
                                                <p>Modifier mon mot de passe</p>
                                            </div>
                                            <IconChevronRight width={16}/>                                
                                        </div>
                                        <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                </Link>

                                <Link to="/app/profile/disclaimer" className="aReset bT">
                                        <div className="horizontal iCenter spaceBtw">
                                            <div className="horizontal iCenter paddingMenuProfil">
                                                <IconFileCertificate color="green" width={25} className="mrgR10"/>
                                                <p>Mentions légales</p>
                                            </div>
                                            <IconChevronRight width={16}/>                                </div>
                                        <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                </Link>

                                <Link to="/app/profile/contact" className="aReset bT">
                                        <div className="horizontal iCenter spaceBtw">
                                            <div className="horizontal iCenter paddingMenuProfil">
                                                <IconBrandHipchat color="green" width={25} className="mrgR10"/>
                                                <p>Nous contacter</p>
                                            </div>
                                            <IconChevronRight width={16}/>
                                        </div>
                                        <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                </Link>

                                <div className="aReset bT" style={{ cursor: 'pointer' }} onClick={openRefer}>
                                        <div className="horizontal iCenter spaceBtw">
                                            <div className="horizontal iCenter paddingMenuProfil">
                                                <IconGift color="green" width={25} className="mrgR10"/>
                                                <p>Parrainer</p>
                                            </div>
                                            <IconChevronRight width={16}/>
                                        </div>
                                        <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                </div>
                            </div>

                            <div className='mrgB100'></div>

                            <div className='mrgB150'></div>

                        </div>
                    </>   
                ) : (                    
                    <>
                        <AppNavbarSyndic />
                        
                        <div className="vertical width50pCenter mrgB10">
                            <div className="vertical iCenter mrgT50 mrgB20">
                                <p className='txt22 medium noMrgB'>{menuProfile.firstname} {menuProfile.lastname}</p>
                                <p className='txt17 capitals dGreyT noMrgT noMrgB'>{menuProfile.company.name}</p>
                            </div>

                            <div style={{ width: "60%", margin: "0 auto" }}>
                            {co2Impact && (co2Impact.asSellerKg > 0 || co2Impact.asBuyerKg > 0) && (
                                <div className="mrgB20">
                                    <p className='txt13 bold dGreyT noMrgB'>Votre impact</p>
                                    <div className="horizontal iCenter spaceBtw radiusgreen" style={{ backgroundColor: '#f1f8f2', padding: '12px 16px', gap: 10 }}>
                                        <div className="vertical" style={{ flex: 1 }}>
                                            <div className="horizontal iCenter" style={{ gap: 6 }}>
                                                <IconLeaf color="#2e7d32" width={18} />
                                                <p className='txt13 noMrgTB'>Ventes/dons</p>
                                            </div>
                                            <p className='txt15 bold noMrgTB' style={{ color: '#2e7d32' }}>{fmtCo2(co2Impact.asSellerKg)}</p>
                                        </div>
                                        <div className="vertical" style={{ flex: 1 }}>
                                            <div className="horizontal iCenter" style={{ gap: 6 }}>
                                                <IconRecycle color="#2e7d32" width={18} />
                                                <p className='txt13 noMrgTB'>Achats</p>
                                            </div>
                                            <p className='txt15 bold noMrgTB' style={{ color: '#2e7d32' }}>{fmtCo2(co2Impact.asBuyerKg)}</p>
                                        </div>
                                    </div>
                                    <p className='txt11 thin dGreyT noMrgT'>potentiellement évités grâce au réemploi</p>
                                </div>
                            )}

                                <NavLink to = "/app/offers/list" className="btnReset aReset bT">
                                    <div className="horizontal iCenter spaceBtw bDarkGreen mrgB30 radiusgreen">
                                        <div className="horizontal iCenter paddingMenuProfil">
                                            <IconArticle color="green" width={25} className="mrgR10"/>
                                            <p className='bold txt20'>Mes offres</p>
                                        </div>
                                    </div>
                                </NavLink>

                                <div  className="profil-menu vertical mrgL10 mrgR20 mrgB20">
                                    <Link to={`/app/profile/orders`} className="aReset bT">
                                            <div className="horizontal iCenter spaceBtw">
                                                <div className="horizontal iCenter paddingMenuProfil">
                                                    <IconReceipt  color="green" width={25} className="mrgR10"/>
                                                    <p>Mes transactions</p>
                                                </div>
                                                <IconChevronRight width={16}/>                                
                                            </div>
                                            <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                    </Link>

                                    
                                    <Link to={`/app/profile/account`} className="aReset bT">
                                            <div className="horizontal iCenter spaceBtw">
                                                <div className="horizontal iCenter paddingMenuProfil">
                                                    <IconUser color="green" width={25} className="mrgR10"/>
                                                    <p>Mon compte</p>
                                                </div>
                                                <IconChevronRight width={16}/>                                
                                            </div>
                                            <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                    </Link>

                                    <Link to={`/app/profile/param/psw-edit`} className="aReset bT">
                                            <div className="horizontal iCenter spaceBtw">
                                                <div className="horizontal iCenter paddingMenuProfil">
                                                    <IconLock color="green" width={25} className="mrgR10"/>
                                                    <p>Modifier mon mot de passe</p>
                                                </div>
                                                <IconChevronRight width={16}/>                                
                                            </div>
                                            <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                    </Link>

                                    <Link to="/app/profile/disclaimer" className="aReset bT">
                                            <div className="horizontal iCenter spaceBtw">
                                                <div className="horizontal iCenter paddingMenuProfil">
                                                    <IconFileCertificate color="green" width={25} className="mrgR10"/>
                                                    <p>Mentions légales</p>
                                                </div>
                                                <IconChevronRight width={16}/>                                </div>
                                            <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                    </Link>

                                    <Link to="/app/profile/contact" className="aReset bT">
                                            <div className="horizontal iCenter spaceBtw">
                                                <div className="horizontal iCenter paddingMenuProfil">
                                                    <IconBrandHipchat color="green" width={25} className="mrgR10"/>
                                                    <p>Nous contacter</p>
                                                </div>
                                                <IconChevronRight width={16}/>
                                            </div>
                                            <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                    </Link>

                                    <div className="aReset bT" style={{ cursor: 'pointer' }} onClick={openRefer}>
                                            <div className="horizontal iCenter spaceBtw">
                                                <div className="horizontal iCenter paddingMenuProfil">
                                                    <IconGift color="green" width={25} className="mrgR10"/>
                                                    <p>Parrainer</p>
                                                </div>
                                                <IconChevronRight width={16}/>
                                            </div>
                                            <hr style={{ border: 'none', borderTop: '1px solid #ebebeb', margin: '0.5rem 0' }} />
                                    </div>
                                </div>

                                <div className='mrgB100'></div>

                                <div className='mrgB150'></div>

                            </div>
                        </div>
                    </>
                )}

                <Modal
                    opened={referOpened}
                    onClose={closeReferModal}
                    title="Parrainer une entreprise"
                    centered
                    withCloseButton={!referSending}
                    closeOnClickOutside={!referSending}
                >
                    {referSent ? (
                        <p className="txtCenter noMrgTB txt15">Mail envoyé</p>
                    ) : (
                        <>
                            <TextInput
                                label="Email de l'entreprise à inviter"
                                placeholder="entreprise@email.com"
                                value={referEmail}
                                onChange={(e) => setReferEmail(e.currentTarget.value)}
                            />
                            <Button
                                fullWidth
                                mt="md"
                                color="dark"
                                disabled={!referEmail}
                                loading={referSending}
                                onClick={handleSendReferral}
                            >
                                Envoyer l'invitation
                            </Button>
                        </>
                    )}
                </Modal>
            </>
        :
        <div className="loaderWrapper vertical">
            <Loader color="green" size="sm" type="dots" />
            <div className='mrgT5'>Chargement ...</div>
        </div>
    )
    
}

export default ProfileMenu;


